
import _ from 'lodash';
import { createResponse } from '../altFunctions/common';
import { createResponseTypes } from '../cnr/reducers/CreateReducer';
import { dataFix } from '../common/dataFix';

// https://www.sslshopper.com/ssl-checker.html

const fetchGenericTypes = {
  fetchGeneric: 'fetchGeneric',
}

const fetchFunctionTypes = {
  fetchData_multi: 'fetchData_multi',
  fetchData: 'fetchData',
  fetchTableData: 'fetchTableData',
  getFeed: 'getFeed',
  getFeeds: 'getFeeds',
  getGolfCourseInfo: 'getGolfCourseInfo',
  srapeUrl: 'srapeUrl',
  rssToJson: 'rssToJson',
  getSchedule: 'getSchedule',
}

/**
 * 
 * @param {object} callData 
 * @returns - The `data` object {success,result, error}
 */
const callFsFunction = async (fsCall, callData) => {
  const data = await fsCall(fetchGenericTypes.fetchGeneric, callData)
  return data
}

export const fsfn_allFetch = (fsCall) => {
  return {
    fetchData_multi: (urlData) => fsfn_fetchData_multi(fsCall, urlData),
    fetchData: (urlData) => fsfn_fetchData(fsCall, urlData),
    fetchDataAndCreate: (urlData, dispatch) => fsfn_fetchDataAndCreate(fsCall, urlData, dispatch),
    fetchTableData_multi: (urlData) => fsfn_fetchTableData_multi(fsCall, urlData),
    fetchTableData: (urlData) => fsfn_fetchTableData(fsCall, urlData),
    getFeed: (feedUrl, titleSearch) => fsfn_getFeed(fsCall, feedUrl, titleSearch),
    getFeeds: (rssFeeds_home, rssFeeds, titleSearch, contentSearch, logging) => fsfn_getFeeds(fsCall, rssFeeds_home, rssFeeds, titleSearch, contentSearch, logging),
    getSchedule: (feedUrl, weekCount, showLogs) => fsfn_getSchedule(fsCall, feedUrl, weekCount, showLogs),
    rssToJson: (feedUrl, showLogs) => fsfn_rssToJson(fsCall, feedUrl, showLogs),
    srapeUrl: (url) => fsfn_srapeUrl(fsCall, url),
  }
}

const fsfn_getSchedule = async (fsCall, feedUrl, weekCount, showLogs) => {
  const callData = {
    feedUrl,
    weekCount,
    fetchFunctionType: fetchFunctionTypes.getSchedule,
    showLogs,
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error('fsfn_getSchedule - error', error)
    return createResponse(false, 'Not Successfull', createResponseTypes.catchError, error)
  }
  // responseFn && responseFn(response_data)
}

const fsfn_rssToJson = async (fsCall, feedUrl, showLogs) => {
  const callData = {
    feedUrl,
    fetchFunctionType: fetchFunctionTypes.rssToJson,
    showLogs,
    fetchType: 'axios',
    // referer: 'https://triblive.com/'
  }
  try {
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error('fsfn_rssToJson - error', error)
    return createResponse(false, 'Not Successfull', createResponseTypes.catchError, error)
  }
  // responseFn && responseFn(response_data)
}

const fsfn_srapeUrl = async (fsCall, url) => {
  const callData = {
    url,
    headless: true,
    fetchFunctionType: fetchFunctionTypes.srapeUrl
  }
  try {
    const response_data = null //await callFsFunction(fsCall, callData) // OK
    console.log('response_data', response_data)
    return response_data
  } catch (error) {
    console.error('fsfn_srapeUrl - error', error)
    return createResponse(false, 'Not Successfull', createResponseTypes.catchError, error)
  }
  // responseFn && responseFn(response_data)
}

/**
 * 
 * @param {object} urlData 
 * @returns response_data {success, result, error}
 * @description This will get the data from a URL. This does NOT create the event/client info.
 * https://securian.events/index.php/attendeeregistration-event-create-mobile-app.html?eventId=
 */
const fsfn_fetchData = async (fsCall, urlData) => {
  try {
    urlData.ignoreSLL = true
    const callData = { urlData, fetchFunctionType: fetchFunctionTypes.fetchData, showLogs: true }
    console.log('callData', callData)
    const response_data = await callFsFunction(fsCall, callData) // OK 
    let { result } = response_data ?? {}
    if (result) { result = dataFix.removeEmpties(result) }
    return response_data
  } catch (error) {
    console.error('fsfn_fetchData - error', error)
  }
}

/**
 * 
 * @param {object} urlData 
 * @returns response_data {success, result, error}
 * @description This will get the data from a URL. This does NOT create the event/client info.
 * https://securian.events/index.php/attendeeregistration-event-create-mobile-app.html?eventId=
 */
const fsfn_fetchData_multi = async (fsCall, urlData) => {
  try {
    urlData.ignoreSLL = true
    const callData = { urlData, fetchFunctionType: fetchFunctionTypes.fetchData_multi, showLogs: true }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    let { result } = response_data ?? {}
    if (result) { result = dataFix.removeEmpties(result) }
    return response_data
  } catch (error) {
    console.error('fsfn_fetchData - error', error)
  }
}

/** This will get the data from a URL. This does NOT create the event/client info */
const fsfn_fetchDataAndCreate = async (fsCall, fn_cls, urlData, dispatch) => {
  try {
    const callData = {
      urlData,
      fetchFunctionType: fetchFunctionTypes.fetchData
    }
    const response_data = await callFsFunction(fsCall, callData) // OK
    const { success, result } = response_data ?? {}
    if (success) {
      const eventData = { initialData: result }
      return fn_cls.createProject(eventData, null, dispatch).then(response_data => {
        console.log('fsfn_fetchDataAndCreate', 'response_data', response_data);
        return response_data
      })
    } else {
      const previewInfo = {
        projectData: null,
        projectSettings: null,
        previewOk: false,
        message: 'No Event Key found'
      }
      return previewInfo
    }
  } catch (error) {
    console.error(error)
  }
}

/** This will get the data from a URL */
const fsfn_fetchTableData = async (fsCall, urlData) => {
  try {
    const callData = {
      urlData,
      fetchFunctionType: fetchFunctionTypes.fetchData,
      showLogs: true
    }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/** This will get the data from a URL */
const fsfn_fetchTableData_multi = async (fsCall, urlData) => {
  try {
    const callData = {
      urlData,
      fetchFunctionType: fetchFunctionTypes.fetchData_multi,
      showLogs: true
    }
    const response_data = await callFsFunction(fsCall, callData) // OK 
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/** This will get the data from a URL */
// export const fsfn_getGolfCourseInfo = async (fsCall, courseId) => {
//   try {
//     const callData = { courseId, fetchFunctionType: fetchFunctionTypes.getGolfCourseInfo }
//     const response_data = await callFsFunction(fsCall, callData)// OK
//     return response_data
//   } catch (error) {
//     console.error(error)
//   }
// }

/**
 * 
 * @param {string} feedUrl 
 * @param {string} titleSearch 
 * @returns response_data {success, result, error}
 */
const fsfn_getFeed = async (fsCall, feedUrl, titleSearch) => {
  try {
    return {}
    const callData = { fetchFunctionType: fetchFunctionTypes.getFeed, feedUrl, titleSearch, showLogs: true }
    console.log('fsfn_getFeed - callData', callData)
    const response_data = await callFsFunction(fsCall, callData) // OK
    console.log('fsfn_getFeed - response_data', response_data)
    return response_data
  } catch (error) {
    console.error(error)
  }
}

/**
 * 
 * @param {*} rssFeeds_home 
 * @param {*} rssFeeds 
 * @param {*} titleSearch 
 * @param {*} contentSearch 
 * @param {*} logging 
 * @returns srt
 */
const fsfn_getFeeds = async (fsCall, rssFeeds_home, rssFeeds, titleSearch, contentSearch, logging) => {

  try {
    const allFeeds = []
    rssFeeds.forEach(rssF => {
      const _rssHome = rssFeeds_home && rssFeeds_home[rssF]
      const { baseUrl, categories } = _rssHome
      if (baseUrl) {
        if (categories) {
          _.forEach(categories, (category, ck) => {
            if (category?.categoryPath) {
              allFeeds.push({ url: baseUrl + category.categoryPath })
            }
          })
        } else {
          allFeeds.push({ url: baseUrl })
        }
      }
    })

    const callData = {
      fetchFunctionType: fetchFunctionTypes.getFeeds,
      rssFeeds: allFeeds,
      titleSearch,
      contentSearch,
      showLogs: logging && logging.allowLogging && logging.logGetFeeds
    }

    callData.showLogs = true

    const response_data = await callFsFunction(fsCall, callData) // OK  
    const { success, result } = response_data ?? {}
    if (success) {
      const feedResults = {}
      let allItems = []
      result.forEach((res, index) => {
        const { items } = res ?? {}
        items.forEach(item => {
          const f = rssFeeds[index].split('_')
          item.source = _.startCase(f[0])
          item.sortDate = new Date(item.pubDate)
        })
        feedResults[rssFeeds[index]] = res.items
        allItems = [...allItems, ...res.items]
      })
      if (allItems.length > 0) {
        const srt = _.orderBy(allItems, ['sortDate'], ['desc'])
        return srt
      } else {
        return []
      }
    } else {
      return null
    }
  } catch (error) {
    console.error(error)
  }
}